/**
 * Check if the search filter matches the normalized and lowercased data in the specified column
 * @param {Array} headCols - Array of header columns
 * @param {number} idx - Index of the column to check
 * @param {Object} data - Data object containing the values to check
 * @param {Object} filters - Filter object containing the search string
 * @returns {boolean} - Returns true if the search filter matches the data, false otherwise
 */
export function checkFilterMatch(headCols, idx, data, filters) {
  const columnId = headCols[idx].id;
  const value = data[columnId];
  if (!value) {
    return false;
  }

  const normalizedData = value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const normalizedSearch = filters.search
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  return normalizedData.includes(normalizedSearch);
}
